import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionListItem from "flarum/forum/components/DiscussionListItem";
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import DiscussionListState from "flarum/forum/states/DiscussionListState";
import sortTags from 'flarum/tags/utils/sortTags';
import tagsLabel from 'flarum/tags/helpers/tagsLabel';
import icon from "flarum/common/helpers/icon";

/**
 * 帖子模块
 */
export default function discussionContent() {
  extend(DiscussionListState.prototype, "sortMap", function (map){
    if (app.forum.attribute("toggleFilter") == 1 && map.unpopular) {
      delete map.unpopular;
    }
  });

  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    if (items.has('tags')) {
      items.remove('tags');
    }
  });

  extend(DiscussionListItem.prototype, 'cardHeader', function (items) {
    const tags = this.attrs.discussion.tags();

    if (tags && tags.length) {
      const allTags = sortTags(tags);
      const lastTag = allTags[allTags.length - 1];

      if (lastTag.isChild()) {
        items.add('tags',tagsLabel([lastTag]), 200);
      }
    }
  });

  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    if (items.has('share-social')) {
      items.setPriority('share-social', 70);
    }

    if (items.has('filter-toolbar')) {
      items.setPriority('filter-toolbar', 60);
    }
  });

  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;
    const name = discussion.productName();

    if (items.has('tags')) {
      items.remove('tags');
    }

    items.add(
      'tags',
      <div>
        {tagsLabel(discussion.tags(), { link: true })}
        {name ? <span datatype="product" data-theme-id={discussion.id()} className="TagLabel product">{name}</span> : ''}
      </div>,
      5
    );

    items.add(
      'counts',
      <div className="DiscussionHero-counts">
        <span className="DiscussionHero-counts-view item-count">
          {icon('fas fa-eye')}
          {discussion.viewCount()}
        </span>
        <span className="DiscussionHero-counts-reply item-count">
          {icon('fas fa-comment')}
          {discussion.replyCount()}
        </span>
      </div>
    );
  });

  extend(DiscussionHero.prototype, 'view', function (view) {
    view.attrs.style = {};
  });
}
